var _style, _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSportCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glipy_copy_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0AB14C;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,2C15.43,2,2,15.43,2,32s13.43,30,30,30s30-13.43,30-30C61.98,15.44,48.56,2.02,32,2z M19.79,21.17 c0.83-1.54,2.46-2.47,4.21-2.4h13.21c1.74-0.06,3.37,0.87,4.2,2.4l1.98,4.14l-4.79,1.94c-0.5,0.21-1.03,0.31-1.57,0.31 c-0.9-0.12-14.03,0.3-14.44-0.31c-0.85-0.34-3.99-1.61-4.78-1.94L19.79,21.17z M12,31.69c1.19,0.08,2.76-0.29,3.51,0.54l0.59,0.59 H12L12,31.69z M19.81,43.11c0,1.1-0.88,1.99-1.98,2h-2.56c-1.1,0-1.99-0.9-1.99-2v-1.05h6.53L19.81,43.11z M22.22,38.96v1.67h-8.87 c-0.75,0-1.35-0.6-1.35-1.35v-5.03h5.83c0.4-0.01,0.71-0.34,0.7-0.73c0-0.18-0.08-0.36-0.2-0.49c-1.09-1.02-2.42-2.9-4.12-2.77H12 c0.04-2.17,1.83-3.9,4-3.86c0.39,0.01,0.77,0.07,1.14,0.19l0.05,0.02l1.32,0.53c1.4,0.49,4.16,1.95,5.67,1.85h12.85 c0.73,0,1.45-0.14,2.12-0.42c0.89-0.36,4.03-1.63,4.86-1.97c2.06-0.7,4.29,0.41,4.98,2.46c0.13,0.4,0.2,0.82,0.21,1.24v0.1 c-4.18-2.49-9.58-1.12-12.07,3.05c-0.64,1.07-1.05,2.27-1.19,3.52H24.21C23.11,36.97,22.22,37.86,22.22,38.96 C22.22,38.96,22.22,38.96,22.22,38.96z M23.65,40.63v-1.67c0-0.31,0.25-0.56,0.56-0.56h11.7c0.01,0.34,0.05,0.68,0.12,1.02 c0.06,0.41,0.16,0.82,0.3,1.21H23.65z M44.65,45.23c-4.05-0.01-7.33-3.29-7.32-7.34c0.01-4.05,3.29-7.33,7.34-7.32 c2.37,0,4.59,1.15,5.96,3.08c2.34,3.32,1.55,7.9-1.76,10.24C47.63,44.76,46.16,45.23,44.65,45.23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.31,34.25h8.57c0.39-0.01,0.71-0.33,0.71-0.72c-0.01-0.39-0.32-0.7-0.71-0.71h-8.57c-0.39,0.01-0.71,0.33-0.7,0.73 C25.62,33.93,25.93,34.24,26.31,34.25z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 44.65,
    cy: 37.9,
    r: 7.33
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.91,37.3h-2.49v-2.49c0-0.39-0.32-0.72-0.72-0.72s-0.72,0.32-0.72,0.72v2.49h-2.48c-0.4,0-0.72,0.32-0.72,0.72 c0,0.39,0.33,0.71,0.72,0.71c0,0,0,0,0,0h2.48v2.49c0,0.39,0.32,0.72,0.72,0.72s0.72-0.32,0.72-0.72v-2.49h2.49 c0.39-0.01,0.71-0.33,0.7-0.73C48.6,37.61,48.3,37.3,47.91,37.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportCar);
export default __webpack_public_path__ + "static/media/sport-car.c960eef77d0372f7a6883a6cc2e71335.svg";
export { ForwardRef as ReactComponent };